import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import {
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Row,
  Button,
  Input,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';
import { NavLink } from 'react-router-dom';
import BatchesTable from './Batches/batchRecord';
import { useSelector } from 'react-redux';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { compactFilterSelectStyles } from '../../../../../helpers/reactSelectStyles';
import {
  getAPI_GM_GetBatchList,
  getAPI_GM_GetBatchList_ByBatchNumber,
  getAPI_GM_GetCommunication_message_with_paginationAndFilteration,
  getAPI_GM_Stats_List,
  getAPI_GM_Graph_List,
} from '../../../../../constants/APIs';
import Logs from './LogScreen/LogTable';
import Stats from './insightScreen/stats';
import MessageGraph from './insightScreen/components/MessageGraph';
const TABLE_PAGE_SIZE = 10;
const BACKEND_PAGE_SIZE = 50;
const PAGES_PER_CHUNK = Math.max(
  1,
  Math.floor(BACKEND_PAGE_SIZE / TABLE_PAGE_SIZE)
);

const CHANNEL_OPTIONS = [
  { label: 'WhatsApp', value: 'WhatsApp' },
  { label: 'SMS', value: 'SMS' },
  { label: 'Email', value: 'Email' },
];
const SOURCE_OPTIONS = [
  { label: 'Guest Messaging', value: 'GuestMessaging' },
  { label: 'Members', value: 'Members' },
];
const DATE_RANGE_OPTIONS = [
  { label: 'Last 7 Days', value: 'last_7_days' },
  { label: 'Last 30 Days', value: 'last_30_days' },
  { label: 'Last 60 Days', value: 'last_60_days' },
  { label: 'Last 90 Days', value: 'last_90_days' },
  { label: 'This Week', value: 'this_week' },
  { label: 'This Month', value: 'this_month' },
  { label: 'Previous Month', value: 'previous_month' },
  { label: 'Year to Date', value: 'ytd' },
  { label: 'Last Year', value: 'last_year' },
  { label: 'Date Range', value: 'custom_range' },
];

const formatDateTimeFromUTC = (value, timeZone) => {
  if (!value) return '-';
  return moment.utc(value).tz(timeZone).format('MMM DD, YYYY hh:mm a');
};

const GuestMessagingInsight_logs = () => {
  const [activeTab, setActiveTab] = useState('insights');
  const [sourceType, setSourceType] = useState(SOURCE_OPTIONS[0]);
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  // Filters
  const [batchNumber, setBatchNumber] = useState('');
  const [channel, setChannel] = useState(null);
  const [firstActiveDate, setFirstActiveDate] = useState(
    moment().subtract(1, 'day').startOf('day').toDate()
  );

  const [lastActiveDate, setLastActiveDate] = useState(
    moment().endOf('day').toDate()
  );

  // Pagination state
  const [logs, setLogs] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [chunkPage, setChunkPage] = useState(0);
  const [tablePage, setTablePage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  //batches
  const [batchSelect, setBatchSelect] = useState({ label: 'All', value: 1 });
  const [batches, setBatches] = useState([]);
  const batchSelectRef = useRef(batchSelect.value);
  const skipAutoFetchRef = useRef(false);
  const isInitialLogsFetchRef = useRef(true);
  const isUserClearedFilterRef = useRef(false);

  //stats
  const [statsData, setStatsData] = useState([]);
  const [statsLoading, setStatsLoading] = useState(false);
  const [selectedRange, setSelectedRange] = useState(DATE_RANGE_OPTIONS[0]);
  const [isDateRangeModalOpen, setIsDateRangeModalOpen] = useState(false);
  const [customFromDate, setCustomFromDate] = useState(null);
  const [customToDate, setCustomToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // stats graph
  const [graphData, setGraphData] = useState([]);
  const [graphLoading, setGraphLoading] = useState(false);

  //paginations
  const chunkPageRef = useRef(0);
  const tablePageRef = useRef(0);
  const pendingTablePageRef = useRef(null);

  const {
    propertyId,
    groupId: storedGroupId,
    timeZone,
  } = useSelector(({ settings }) => ({
    propertyId: settings.propertyId,
    groupId: settings.groupId,
    timeZone: settings.timeZone,
  }));
  const groupId = storedGroupId || getGroupID();

  const styleCss = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
        top:auto !important;
        bottom: 0 !important;
      }
      .nav-tabs .nav-link {
        border: none;
      }
      .nav-tabs .nav-link.active,
      .nav-tabs .nav-link:hover {
        background-color: transparent;
      }`;
  useEffect(() => {
    chunkPageRef.current = chunkPage;
  }, [chunkPage]);

  useEffect(() => {
    tablePageRef.current = tablePage;
  }, [tablePage]);

  useEffect(() => {
    if (batchSelect?.value !== undefined) {
      batchSelectRef.current = batchSelect.value;
    }
  }, [batchSelect]);

  const toggleFilterPanel = () => {
    if (activeTab === 'logs') {
      setIsFilterPanelOpen((prev) => !prev);
    }
  };

  const handleClearStatusFilter = () => {
    if (activeTab !== 'logs') return;
    skipAutoFetchRef.current = true;
    isInitialLogsFetchRef.current = false;
    isUserClearedFilterRef.current = true;

    setBatchNumber('');
    setChannel(null);
    setFirstActiveDate(null);
    setLastActiveDate(null);
    setLogs([]);
    setTotalItems(0);
    setIsFilterPanelOpen(false);
  };

  const handleApplyStatusFilter = () => {
    if (activeTab !== 'logs') return;
    if (
      !channel &&
      !batchNumber &&
      firstActiveDate === null &&
      lastActiveDate === null
    ) {
      NotificationManager.warning(
        'Apply at least one filter before loading logs',
        'Warning',
        3000
      );
      return;
    }

    resetPagination();
    fetchLogs(0);
    setIsFilterPanelOpen(false);
  };

  const resetPagination = useCallback(() => {
    pendingTablePageRef.current = 0;
    setChunkPage(0);
    setTablePage(0);
  }, []);

  const formatAction = (value = '') => {
    if (!value) return '-';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  const formatChannel = (value = '') => {
    if (!value) return '-';

    const normalized = value.toLowerCase();

    if (normalized === 'whatsapp') return 'WhatsApp'; // special case

    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  };

  // fetch batchlist
  const fetchBatchList = useCallback(
    async (selectValue = batchSelect.value) => {
      setLoading(true);
      try {
        const res = await AxiosAPI({
          method: 'get',
          url: getAPI_GM_GetBatchList,
          params: {
            groupId,
            propertyId,
            select: selectValue,
            sourceType: sourceType.value,
          },
        });

        const list = Array.isArray(res.data) ? res.data : [];
        setBatches(list);
      } catch (err) {
        NotificationManager.error('Failed to load batches', 'Error', 3000);
        setBatches([]);
      } finally {
        setLoading(false);
      }
    },
    [groupId, propertyId, batchSelect.value, sourceType]
  );

  useEffect(() => {
    fetchBatchList(batchSelectRef.current);
  }, [fetchBatchList]);

  // Fetch Logs API call

  const getDefaultFromDate = () =>
    moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD');

  const getDefaultToDate = () => moment().endOf('day').format('YYYY-MM-DD');

  const fetchLogs = useCallback(
    async (targetChunkPage = 0) => {
      const chunkToLoad =
        typeof targetChunkPage === 'number'
          ? targetChunkPage
          : chunkPageRef.current || 0;

      setLoading(true);

      try {
        const res = await AxiosAPI({
          method: 'get',
          url: getAPI_GM_GetCommunication_message_with_paginationAndFilteration,
          params: {
            pageNumber: chunkToLoad + 1,
            pageSize: BACKEND_PAGE_SIZE,
            groupId,
            propertyId,
            firstActiveDate: firstActiveDate
              ? moment(firstActiveDate).startOf('day').format('YYYY-MM-DD')
              : isInitialLogsFetchRef.current
                ? getDefaultFromDate()
                : '',

            lastActiveDate: lastActiveDate
              ? moment(lastActiveDate).endOf('day').format('YYYY-MM-DD')
              : isInitialLogsFetchRef.current
                ? getDefaultToDate()
                : '',

            channel: channel?.value || '',
            batchNumber: batchNumber || '',
            sourceType: sourceType.value,
          },
        });

        const {
          communicationMessages = [],
          totalPages = 0,
          totalItems = 0,
        } = res.data || {};

        setLogs(
          Array.isArray(communicationMessages) ? communicationMessages : []
        );

        setChunkPage(chunkToLoad);
        setTotalItems(totalItems);

        const totalTablePages =
          totalItems > 0 ? Math.ceil(totalItems / TABLE_PAGE_SIZE) : 0;
        const chunkStartPage = chunkToLoad * PAGES_PER_CHUNK;
        const chunkEndPage = chunkStartPage + PAGES_PER_CHUNK - 1;
        let resolvedPage;

        if (pendingTablePageRef.current !== null) {
          resolvedPage = pendingTablePageRef.current;
          pendingTablePageRef.current = null;
        } else if (
          chunkToLoad === chunkPageRef.current &&
          tablePageRef.current >= chunkStartPage &&
          tablePageRef.current <= chunkEndPage
        ) {
          resolvedPage = tablePageRef.current;
        } else {
          resolvedPage = chunkStartPage;
        }

        if (totalTablePages > 0) {
          resolvedPage = Math.min(resolvedPage, totalTablePages - 1);
        } else {
          resolvedPage = 0;
        }

        setTablePage(Math.max(resolvedPage, chunkStartPage));
      } catch (err) {
        NotificationManager.error('Failed to load logs', 'Error', 3000);
        setLogs([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [
      batchNumber,
      channel,
      firstActiveDate,
      lastActiveDate,
      groupId,
      propertyId,
      sourceType,
    ]
  );

  useEffect(() => {
    if (activeTab !== 'logs') {
      skipAutoFetchRef.current = false;
      return;
    }

    if (!isUserClearedFilterRef.current) {
      isInitialLogsFetchRef.current = true;
    } else {
      isInitialLogsFetchRef.current = false;
    }

    if (skipAutoFetchRef.current) {
      skipAutoFetchRef.current = false;
      return;
    }

    fetchLogs(0);
  }, [activeTab, fetchLogs]);

  useEffect(() => {
    if (activeTab === 'logs') {
      resetPagination();
      fetchLogs(0);
    }

    if (activeTab === 'batches') {
      fetchBatchList(batchSelectRef.current);
    }
  }, [sourceType, activeTab]);

  //fetch log by batchNumber
  const fetchLogsByBatchNumber = useCallback(
    async (batchNo) => {
      try {
        setLoading(true);

        const res = await AxiosAPI({
          method: 'get',
          url: getAPI_GM_GetBatchList_ByBatchNumber,
          params: {
            groupId,
            propertyId,
            select: batchSelectRef.current,
            batchNumber: batchNo,
            sourceType: sourceType.value,
          },
        });

        const apiRows = Array.isArray(res.data) ? res.data : [];

        setLogs(apiRows);
        setTotalItems(apiRows.length);
        setChunkPage(0);
        setTablePage(0);
      } catch (err) {
        NotificationManager.error('Failed to load batch logs', 'Error', 3000);
        setLogs([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [groupId, propertyId, sourceType]
  );

  //fetchStats

  const fetchStats = useCallback(async () => {
    setStatsLoading(true);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: getAPI_GM_Stats_List,
        params: {
          fromDate: fromDate
            ? moment(fromDate).format('YYYY-MM-DD')
            : moment().subtract(7, 'days').format('YYYY-MM-DD'),
          toDate: toDate
            ? moment(toDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD'),
          groupId,
          sourceType: sourceType.value,
        },
      });

      setStatsData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      NotificationManager.error('Failed to load stats', 'Error', 3000);
      setStatsData([]);
    } finally {
      setStatsLoading(false);
    }
  }, [fromDate, toDate, groupId, sourceType]);

  const fetchGraphData = useCallback(async () => {
    setGraphLoading(true);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: getAPI_GM_Graph_List,
        params: {
          groupId,
          propertyId: propertyId === '-1' ? null : propertyId,
          fromDate: fromDate
            ? moment(fromDate).format('YYYY-MM-DD')
            : moment().subtract(7, 'days').format('YYYY-MM-DD'),
          toDate: toDate
            ? moment(toDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD'),
          sourceType: sourceType.value,
        },
      });

      setGraphData(res.data?.dateData || res.data || []);
    } catch (err) {
      NotificationManager.error('Failed to load graph data', 'Error', 3000);
      setGraphData([]);
    } finally {
      setGraphLoading(false);
    }
  }, [groupId, propertyId, fromDate, toDate, sourceType]);

  useEffect(() => {
    if (activeTab === 'insights') {
      fetchStats();
      fetchGraphData();
    }
  }, [activeTab, fetchStats, fetchGraphData, fromDate, toDate]);

  // Map Log Api
  const rows = useMemo(
    () =>
      logs.map((item) => ({
        batch: item.batchNumber || '-',
        dateTime: formatDateTimeFromUTC(item.createdDate, timeZone) || '-',
        reservation: item.reservationId || '-',
        phone: item.phone || '-',
        email: item.email || '-',
        trigger: item.trigger || '-',
        action: formatAction(item.action) || '-',
        channel: formatChannel(item.channel) || '-',
        message: item.message || '-',
        failureReason: item.failureReason || '-',
        sourceType: item.sourceType || sourceType.label,
      })),
    [logs, sourceType]
  );

  // Map batch Api
  const batchRows = useMemo(
    () =>
      batches.map((x) => ({
        dateTime: formatDateTimeFromUTC(x.createdDate, timeZone) || '-',
        trigger: x.trigger || '-',
        action: formatAction(x.action) || '-',
        channel: formatChannel(x.channel) || '-',
        message: x.message || '-',
        totalSent: x.totalSent || 0,
        totalDelivered: x.totalDelivered || 0,
        sourceType: x.sourceType || sourceType.label,
        batchNumber: x.batchNumber, // IMPORTANT
      })),
    [batches, sourceType]
  );

  // Pagination slice
  const chunkRelativePage = Math.max(
    0,
    tablePage - chunkPage * PAGES_PER_CHUNK
  );
  const currentPageRows = useMemo(() => {
    const start = chunkRelativePage * TABLE_PAGE_SIZE;
    return rows.slice(start, start + TABLE_PAGE_SIZE);
  }, [logs, chunkRelativePage]);

  const totalTablePages =
    totalItems > 0 ? Math.ceil(totalItems / TABLE_PAGE_SIZE) : 0;

  const handlePageChange = (nextPage) => {
    const targetChunk = Math.floor(nextPage / PAGES_PER_CHUNK);
    if (targetChunk !== chunkPage) {
      pendingTablePageRef.current = nextPage;
      fetchLogs(targetChunk);
    } else {
      setTablePage(nextPage);
    }
  };
  const handleViewLogsByBatch = useCallback(
    async (batchNo) => {
      if (!batchNo) {
        NotificationManager.warning('Batch number missing', 'Warning', 2000);
        return;
      }
      skipAutoFetchRef.current = true;
      // Move to Logs tab
      setActiveTab('logs');

      // Apply batch filter
      setBatchNumber(batchNo);
      setChannel(null);
      setFirstActiveDate(null);
      setLastActiveDate(null);

      resetPagination();

      await fetchLogsByBatchNumber(batchNo);
    },
    [fetchLogsByBatchNumber, resetPagination]
  );

  const refreshLogsChunk = useCallback(() => {
    pendingTablePageRef.current = tablePageRef.current;

    fetchLogs(chunkPageRef.current);
  }, [fetchLogs]);

  const isMoreThanOneYear = (startDate, endDate) => {
    const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;
    return Math.abs(endDate - startDate) >= ONE_YEAR_IN_MS;
  };
  const isMoreThanThreeMonths = (startDate, endDate) => {
    const THREE_MONTHS_IN_MS = 90 * 24 * 60 * 60 * 1000;
    return Math.abs(endDate - startDate) > THREE_MONTHS_IN_MS;
  };

  const isYearMonthView = useMemo(() => {
    if (!selectedRange) return false;

    if (selectedRange.value === 'last_year') return true;

    if (selectedRange.value === 'custom_range' && fromDate && toDate) {
      return isMoreThanThreeMonths(fromDate, toDate);
    }

    return false;
  }, [selectedRange, fromDate, toDate]);
  const formatDateForTable = (date) => {
    if (!date) return '-';

    return isYearMonthView
      ? moment(date).format('MMM YYYY')
      : moment(date).format('MMM DD, YYYY');
  };

  const statsRows = useMemo(() => {
    const grouped = {};

    statsData.forEach((item) => {
      const date = formatDateForTable(item.dateWise);
      const triggerName = item.triggerName || '-';

      const key = `${date}_${triggerName}`;

      if (!grouped[key]) {
        grouped[key] = {
          date,
          triggername: triggerName,
          messagedelivered: [],
          messagesreceived: [],
        };
      }

      item.triggersTotalData?.forEach((totalItem) => {
        totalItem.channels?.forEach((ch) => {
          grouped[key].messagedelivered.push({
            channel: ch.channelType,
            count: ch.noOfCount ?? 0,
          });
        });
      });

      item.triggersSuccessData?.forEach((successItem) => {
        grouped[key].messagesreceived.push({
          channel: successItem.channelType,
          count: successItem.noOfCount ?? 0,
        });
      });
    });

    return Object.values(grouped);
  }, [statsData]);

  const applyDateRange = (rangeValue) => {
    let fromDate = null;
    let toDate = moment();

    switch (rangeValue) {
      case 'last_7_days':
        fromDate = moment().subtract(7, 'days');
        break;
      case 'last_30_days':
        fromDate = moment().subtract(30, 'days');
        break;
      case 'last_60_days':
        fromDate = moment().subtract(60, 'days');
        break;
      case 'last_90_days':
        fromDate = moment().subtract(90, 'days');
        break;
      case 'this_week':
        fromDate = moment().startOf('isoWeek');
        break;
      case 'this_month':
        fromDate = moment().startOf('month');
        break;
      case 'previous_month':
        fromDate = moment().subtract(1, 'month').startOf('month');
        toDate = moment().subtract(1, 'month').endOf('month');
        break;
      case 'ytd':
        fromDate = moment().startOf('year');
        break;
      case 'last_year':
        fromDate = moment().subtract(1, 'year').startOf('year');
        toDate = moment().subtract(1, 'year').endOf('year');
        break;
      default:
        return;
    }

    setFromDate(fromDate.toDate());
    setToDate(toDate.toDate());
  };

  const handleDateRangeChange = (option) => {
    setSelectedRange(option);

    if (option.value === 'custom_range') {
      setIsDateRangeModalOpen(true);
      return;
    }

    applyDateRange(option.value);
  };

  return (
    <Fragment>
      {/* Tabs */}
      <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-0 mr-0">
        <style>{styleCss}</style>
        {/* Insights */}
        <NavItem className="text-center" style={{ width: 'auto' }}>
          <NavLink
            to="#"
            style={{ background: 'none', cursor: 'pointer' }}
            location={{}}
            className={classnames({
              active: activeTab === 'insights',
              'nav-link': true,
            })}
            onClick={() => toggleTab('insights')}
          >
            <span
              style={{
                color:
                  activeTab === 'insights' ? 'var(--theme-color-1)' : '#8f8f8f',
              }}
            >
              Insights
            </span>
          </NavLink>
        </NavItem>

        {/* Batches */}
        <NavItem className="text-center" style={{ width: 'auto' }}>
          <NavLink
            to="#"
            style={{ background: 'none', cursor: 'pointer' }}
            location={{}}
            className={classnames({
              active: activeTab === 'batches',
              'nav-link': true,
            })}
            onClick={() => toggleTab('batches')}
          >
            <span
              style={{
                color:
                  activeTab === 'batches' ? 'var(--theme-color-1)' : '#8f8f8f',
              }}
            >
              Batches
            </span>
          </NavLink>
        </NavItem>

        {/* Logs */}
        <NavItem className="text-center" style={{ width: 'auto' }}>
          <NavLink
            to="#"
            style={{ background: 'none', cursor: 'pointer' }}
            location={{}}
            className={classnames({
              active: activeTab === 'logs',
              'nav-link': true,
            })}
            onClick={() => toggleTab('logs')}
          >
            <span
              style={{
                color:
                  activeTab === 'logs' ? 'var(--theme-color-1)' : '#8f8f8f',
              }}
            >
              Logs
            </span>
          </NavLink>
        </NavItem>
      </Nav>

      {activeTab === 'logs' && (
        <div
          className="position-relative"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16,
          }}
        >
          <Button
            color="primary"
            size="xs"
            className="d-flex align-items-center"
            style={{ height: 36 }}
            onClick={toggleFilterPanel}
          >
            <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
            Filters
            <i
              className={`simple-icon-arrow-${isFilterPanelOpen ? 'up' : 'down'} ml-2`}
              style={{ fontSize: 10 }}
            />
          </Button>

          {isFilterPanelOpen && (
            <div
              className="reservation-filter-panel"
              style={{
                position: 'absolute',
                top: '110%',
                // left: 0,
                width: 260,
                zIndex: 12,
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 10px 30px rgba(15, 34, 58, 0.15)',
                padding: '16px',
              }}
            >
              <div className="mb-3">
                <label className="text-small font-weight-semibold d-block mb-1">
                  Log Filters
                </label>

                {/* Example — Map your existing filters here */}
                <Input
                  value={batchNumber}
                  onChange={(e) => setBatchNumber(e.target.value)}
                  placeholder="Batch number"
                  className="mb-2"
                />

                <Select
                  value={channel}
                  className="react-select mb-2"
                  classNamePrefix="react-select"
                  options={CHANNEL_OPTIONS}
                  onChange={setChannel}
                  placeholder="Channel"
                />

                <DatePicker
                  selected={firstActiveDate}
                  onChange={setFirstActiveDate}
                  className="form-control mb-2"
                  placeholderText="From date"
                  dateFormat="dd/MM/yyyy"
                />

                <DatePicker
                  selected={lastActiveDate}
                  onChange={setLastActiveDate}
                  className="form-control"
                  placeholderText="To date"
                  dateFormat="dd/MM/yyyy"
                />
              </div>

              <div className="d-flex justify-content-end">
                <Button
                  size="xs"
                  color="secondary"
                  onClick={handleClearStatusFilter}
                >
                  Clear
                </Button>
                <Button
                  size="xs"
                  color="primary"
                  className="ml-2"
                  onClick={handleApplyStatusFilter}
                >
                  Apply
                </Button>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Select
              value={sourceType}
              classNamePrefix="insights-filter-select"
              styles={compactFilterSelectStyles}
              compactWidth={160}
              compactHeight={36}
              options={SOURCE_OPTIONS}
              onChange={(opt) => {
                setSourceType(opt);
                resetPagination();
              }}
              placeholder="Source"
              isSearchable={false}
            />
          </div>
        </div>
      )}
      {activeTab !== 'logs' && (
        <div
          className="d-flex justify-content-end align-items-center mb-3"
          style={{ gap: 8 }}
        >
          {activeTab === 'insights' && (
            <div>
              <Select
                value={selectedRange}
                classNamePrefix="insights-filter-select"
                styles={compactFilterSelectStyles}
                compactWidth={160}
                options={DATE_RANGE_OPTIONS}
                onChange={handleDateRangeChange}
                placeholder="Filter"
                isSearchable={false}
              />
            </div>
          )}

          {activeTab === 'batches' && (
            <div>
              <Select
                value={batchSelect}
                classNamePrefix="insights-filter-select"
                styles={compactFilterSelectStyles}
                compactWidth={100}
                options={[
                  { label: 'All', value: 1 },
                  { label: 'Today', value: 0 },
                ]}
                onChange={(opt) => {
                  setBatchSelect(opt);
                  batchSelectRef.current = opt.value;
                  fetchBatchList(opt.value);
                }}
                placeholder="Select"
                isSearchable={false}
              />
            </div>
          )}

          <div>
            <Select
              value={sourceType}
              classNamePrefix="insights-filter-select"
              styles={compactFilterSelectStyles}
              compactWidth={160}
              options={SOURCE_OPTIONS}
              onChange={(opt) => {
                setSourceType(opt);
                resetPagination();
              }}
              placeholder="Source"
              isSearchable={false}
            />
          </div>
        </div>
      )}

      {/* CONTENT */}
      <TabContent activeTab={activeTab}>
        <TabPane tabId="insights">
          {graphLoading && <div className="loading" />}
          {!graphLoading && (
            <MessageGraph
              apiData={graphData}
              fromDate={fromDate}
              toDate={toDate}
              isYearMonthView={isYearMonthView}
            >
              <Stats data={statsRows} />
            </MessageGraph>
          )}
        </TabPane>

        <TabPane tabId="batches">
          <BatchesTable
            data={batchRows}
            loading={loading}
            onOpenLogs={handleViewLogsByBatch}
          />
        </TabPane>

        <TabPane tabId="logs">
          <Logs
            data={currentPageRows}
            loading={loading}
            onRefresh={refreshLogsChunk}
            page={tablePage}
            pageSize={TABLE_PAGE_SIZE}
            totalPages={totalTablePages}
            totalItems={totalItems}
            pagesPerChunk={PAGES_PER_CHUNK}
            onPageChange={handlePageChange}
            showSourceType={true}
            sourceType={sourceType}
          />
        </TabPane>
      </TabContent>
      {isDateRangeModalOpen && (
        <div
          className="modal fade show d-block"
          style={{ background: 'rgba(0,0,0,0.5)' }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ alignItems: 'start', boxShadow: 'none' }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5>Date Range</h5>
                <button
                  className="close"
                  onClick={() => setIsDateRangeModalOpen(false)}
                >
                  ×
                </button>
              </div>

              <div className="modal-body">
                <Row>
                  <Colxx xxs="6">
                    <label>Start Date</label>
                    <DatePicker
                      selected={customFromDate}
                      onChange={setCustomFromDate}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                    />
                  </Colxx>

                  <Colxx xxs="6">
                    <label>End Date</label>
                    <DatePicker
                      selected={customToDate}
                      onChange={setCustomToDate}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                    />
                  </Colxx>
                </Row>
              </div>

              <div className="modal-footer">
                <Button
                  color="primary"
                  onClick={() => {
                    if (!customFromDate || !customToDate) {
                      NotificationManager.warning(
                        'Select both dates',
                        'Warning'
                      );
                      return;
                    }
                    if (isMoreThanOneYear(customFromDate, customToDate)) {
                      NotificationManager.error(
                        'The start and end date must be within a year of each other.',
                        'Invalid Date Range'
                      );
                      return;
                    }

                    setFromDate(customFromDate);
                    setToDate(customToDate);
                    setIsDateRangeModalOpen(false);
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="secondary"
                  onClick={() => setIsDateRangeModalOpen(false)}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default GuestMessagingInsight_logs;
